export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    const { routerPreFix } = require('$proDirname/prefix');
    //  设置 spa 的路由前缀
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.lottery}/index`;

    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/smash-eggs`
        },
        {
          name: 'smash-eggs',
          path: `${prefix}/smash-eggs`,
          component: resolve => import('./smash-eggs').then(resolve)
        },
        {
          name: 'reward-list',
          path: `${prefix}/reward-list`,
          component: resolve => import('./reward-list').then(resolve)
        },
        {
          name: 'turntable',
          path: `${prefix}/turntable`,
          component: resolve => import('./turntable').then(resolve)
        },
        {
          name: 'chinese-new-year',
          path: `${prefix}/chinese-new-year`,
          component: resolve => import('./chinese-new-year').then(resolve)
        },
        {
          name: 'valentine-day',
          path: `${prefix}/valentine-day`,
          component: resolve => import('./valentine-day').then(resolve)
        },
        {
          name: 'cambodian-new-year',
          path: `${prefix}/cambodian-new-year`,
          component: resolve => import('./cambodian-new-year').then(resolve)
        },
        {
          name: 'lottery-share',
          path: `${prefix}/lottery-share`,
          component: resolve => import('./lottery-share').then(resolve)
        },
        {
          name: 'sleepless-city',
          path: `${prefix}/sleepless-city`,
          component: resolve => import('./sleepless-city').then(resolve)
        },
        {
          name: 'slot-machine',
          path: `${prefix}/slot-machine`,
          component: resolve => import('./slot-machine').then(resolve)
        },
        {
          name: 'lucky-elephant',
          path: `${prefix}/lucky-elephant`,
          component: resolve => import('./lucky-elephant').then(resolve)
        },
        {
          name: 'lucky-elephant-rule',
          path: `${prefix}/lucky-elephant-rule`,
          component: resolve => import('./lucky-elephant/rule').then(resolve)
        },
        {
          name: 'lucky-elephant-record',
          path: `${prefix}/lucky-elephant-record`,
          component: resolve => import('./lucky-elephant/record').then(resolve)
        },
        {
          name: 'daily-rewards',
          path: `${prefix}/daily-rewards`,
          component: resolve => import('./daily-rewards').then(resolve)
        },
        {
          name: 'christmas-mystery',
          path: `${prefix}/christmas-mystery`,
          component: resolve => import('./christmas-mystery').then(resolve)
        },
        {
          name: 'christmas-reward-list',
          path: `${prefix}/christmas-reward-list`,
          component: resolve => import('./christmas-reward-list').then(resolve)
        },
        {
          name: 'new-years-day',
          path: `${prefix}/new-years-day`,
          component: resolve => import('./new-years-day').then(resolve)
        },
      ]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      if (window.$vm?.$Statistics) {
        window.$vm?.$Statistics.onEvent('page', from.name, {
          url: window.location.href
        });
      }
      loadLanguageAsync({
        router: to.name
      })
        .then(() => next())
        .catch(() => next());
    });
    return router;
  }
};
